<div>
  <div>
    <span *ngIf="label" class="label">{{label | translate }}</span>
    <span *ngIf="isRequired" class="text-danger-500 font-bold px-1">*</span>
  </div>
  <span *ngIf="helperText" class="helper-text">{{helperText | translate}}</span>
</div>
